import type { ComponentProps, FC, ReactNode } from 'react';
import { useState } from 'react';

import { Body, Container, Controls } from './styled';

import { Link } from '../Link';

export type IAccordionProps = ComponentProps<typeof Container> & {
    title: string;
    isInitiallyOpen?: boolean;
    children: ReactNode;
};

export const Accordion: FC<IAccordionProps> = ({
    title,
    isInitiallyOpen,
    children,
    ...props
}) => {
    const [isOpen, setIsOpen] = useState(isInitiallyOpen ?? false);
    return (
        <Container isOpen={isOpen} {...props}>
            <Controls type="button" onClick={() => setIsOpen(!isOpen)}>
                <span>{title}</span>
                <Link>{isOpen ? 'Hide' : 'Show'}</Link>
            </Controls>
            <Body isOpen={isOpen}>{children}</Body>
        </Container>
    );
};

Accordion.defaultProps = {
    isInitiallyOpen: false,
};
